import { useEffect, useState } from "react";
import { Radio, Sparkles } from "lucide-react";

const DYNAMIC_LABELS = {
  trivia: "Trivia relámpago",
  reto: "Reto de regreso",
  votacion: "Votación en vivo",
  recompensa: "Recompensa sorpresa",
};

const getRemaining = (endsAt) => Math.max(0, new Date(endsAt).getTime() - Date.now());

export const BroadcastModeBanner = ({ state }) => {
  const [remaining, setRemaining] = useState(() => getRemaining(state.commercial_ends_at));
  const isCommercial = state.mode === "commercials";

  useEffect(() => {
    if (!isCommercial || !state.commercial_ends_at) return undefined;
    const updateRemaining = () => setRemaining(getRemaining(state.commercial_ends_at));
    updateRemaining();
    const timer = window.setInterval(updateRemaining, 1000);
    return () => window.clearInterval(timer);
  }, [isCommercial, state.commercial_ends_at]);

  const seconds = Math.ceil(remaining / 1000);
  const formatted = `${String(Math.floor(seconds / 60)).padStart(2, "0")}:${String(seconds % 60).padStart(2, "0")}`;

  if (!isCommercial) {
    return (
      <div data-testid="broadcast-mode-banner-live" className="flex flex-wrap items-center justify-between gap-4 rounded-[1.5rem] border border-mint/30 bg-ink px-5 py-4 text-cream shadow-[0_16px_35px_rgb(0,0,0,0.12)]">
        <div className="flex items-center gap-3">
          <span className="relative flex h-3 w-3"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-mint opacity-80" /><span className="relative h-3 w-3 rounded-full bg-mint" /></span>
          <div><p className="font-mono text-[10px] uppercase tracking-widest text-mint">Transmisión en vivo</p><p className="mt-1 text-sm text-cream/75">La segunda pantalla "app" y el programa TV, siempre.</p></div>
        </div>
        <Radio className="h-5 w-5 text-mint" aria-hidden="true" />
      </div>
    );
  }

  return (
    <div data-testid="broadcast-mode-banner-commercials" className="flex flex-wrap items-center justify-between gap-4 rounded-[1.5rem] border border-gold/60 bg-[#24211a] px-5 py-4 text-cream shadow-[0_16px_35px_rgba(232,197,71,0.16)]">
      <div className="flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-gold text-ink"><Sparkles className="h-5 w-5" /></span>
        <div><p className="font-mono text-[10px] uppercase tracking-widest text-gold">Modo comerciales · segunda pantalla activa</p><p className="mt-1 text-sm text-cream/75">{DYNAMIC_LABELS[state.dynamic] || DYNAMIC_LABELS.trivia} disponible mientras vuelve el programa.</p></div>
      </div>
      <p data-testid="commercial-countdown-display" className="font-mono text-3xl font-bold tracking-widest text-gold">{formatted}</p>
    </div>
  );
};